export const GET_GROWERS = "GET_GROWERS";
export const GET_GROWER_UPDATE = "GET_GROWER_UPDATE";
export const COPY_GROWER = "COPY_GROWER"